export default "<div id=\"react-component--service-settings\"></div>"